import "./SecBarChart.css";

import React from "react";
import { useState, useCallback, useEffect } from "react";
import {
  csv,
  arc,
  pie,
  scaleBand,
  scaleLinear,
  max,
  format,
  tickFormat,
} from "d3";
import BarIcon from "../Icons/BarIcon";

const csvUrl =
  "https://gist.githubusercontent.com/VasumathiArichandran/7202d85fb45f927dbc7fa5bc8db1dabb/raw/d1b6f31b7d3ce46379459ca17cdf50c8691e2aad/BigBarChart.csv";
const width = 147;
const height = 400;
const margin = { top: 5, right: 0, bottom: 10, left: 10 };
export default function SecBarChart() {
  var [data, setData] = useState(null);
  useEffect(() => {
    var row = (d) => {
      d.Population = +d["2050"];
      d.Population1 = +d["2025"];
      return d;
    };
    csv(csvUrl, row).then(setData);
  }, []);

  if (!data) {
    return <pre>Loading...</pre>;
  }
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  console.log(data[15]);

  // data = data.sort(function(a, b) {
  //   return a.Population - b.Population1
  // });

  //scale axis based on data
  // xScale.domain(data.map(d => d.name));

  //xScale0.domain(models.map(d => d.model_name))
  // xScale1.domain(["field1", "field2"]).range([0, xScale0.bandwidth()]);
  // yScale.domain([
  //   0,
  //   d3.max(models, (d) => (d.field1 > d.field2 ? d.field1 : d.field2)),
  // ]);

  const yScale = scaleBand()
    .domain(data.map((d) => d["Country or area"]))
    .range([0, height + 28])
    .padding(0.4);

  const yScale1 = scaleBand();

  yScale1.domain(["Population", "Population1"]).range([0, yScale.bandwidth()]);

  const xScale = scaleLinear()
    .domain([0, max(data, (d) => d.Population)])
    .range([0, innerWidth]);

  console.log(xScale.ticks());
  // var subgroups = data.columns.slice(0);
  // console.log(subgroups);

  // const yScale1 = scaleBand()
  //   .domain(subgroups)
  //   .range([0, yScale.bandwidth()])
  //   .padding(0.1);

  // var yScale1 = scaleBand()
  //   .domain(subgroups)
  //   .range([0, yScale.bandwidth()])
  //   .padding([0.05]);
  return (
    <>
      <div className="SecBarChart">
        <div className="SecBarChartHeading">
          <div className="SecBarChartHeading1">
            <BarIcon />
            <p>User Summary</p>
          </div>
          <div className="SecBarChartButtons">
            <button>Year</button>
            <button>Month</button>
            <button>Week</button>
          </div>{" "}
        </div>

        <svg
          width={width}
          height={height}
          className="SecBarChartBar"
          transform={`rotate(270)`}
        >
          {/* <g transform={`translate(${margin.left},${margin.top})`}> */}
          <g width={width} height={height} transform={`translate(0,10)`}>
            {xScale.ticks(6).map((tickValue) => (
              <g
                key={tickValue}
                transform={`translate(${xScale(tickValue)},0)`}
              >
                {/* <line y2={innerHeight} stroke="#c0c0bb" /> */}
                <text className="xScaleText1" dy="-38.5em" y={innerHeight}>
                  {tickValue + "."}
                </text>
              </g>
            ))}
            {yScale.domain().map((tickValue) => (
              <g>
                <g
                  key={tickValue}
                  transform={`translate(0,${yScale(tickValue) + 12})`}
                >
                  <line x2={width} stroke="#dee0e3" />
                  {/* <circle
                    cx={innerWidth -132}
                    cy={0}
                    r={4}
                    style={{ zIndex: "65" }}
                  ></circle> */}
                </g>

                <g className="gtransform">
                  <text
                    className="xScaleTextSecBar"
                    dx="-31.31em"
                    x={width}
                    y={yScale(tickValue) + yScale.bandwidth() / 2}
                    style={{
                      textAnchor: "middle",
                    }}
                  >
                    {"."}
                  </text>
                </g>
              </g>
            ))}
            {/* <text
              x={innerWidth / 2}
              y={innerHeight}
              style={{ textAnchor: "middle", transform: "rotate(10deg)", fontSize: "10px" }}
            >
              Population
            </text> */}
            {data.map((d) => (
              <>
                {/* <rect
                  className="mark"
                  key={d["Country or area"]}
                  x={0}
                  y={yScale(d["Country or area"])}
                  width={xScale(d.Population)}
                  height={yScale.bandwidth()}
                /> */}

                <rect
                  className="secMark1"
                  key={d["Country or area"]}
                  x={0}
                  y={yScale(d["Country or area"])}
                  rx={2}
                  ry={2}
                  width={xScale(d.Population)}
                  height={yScale1.bandwidth()}
                >
                  <title className="HoverCss">
                    <p>{d["Country or area"]}</p>
                    <p> {d.Population + "%"}</p>
                  </title>
                </rect>

                <rect
                  className="secMark2"
                  key={d["Country or area"]}
                  x={0}
                  y={yScale(d["Country or area"]) + 14}
                  rx={2}
                  ry={2}
                  width={xScale(d.Population1)}
                  height={yScale1.bandwidth()}
                >
                  <title>{d.Population1}</title>
                </rect>
                <g
                  key={d["Country or area"]}
                  // transform={`translate(0,${yScale(tickValue) + 12})`}
                >
                  {/* <line x2={width} stroke="#dee0e3" /> */}
                  <circle
                    cy={yScale(d["Country or area"]) + 14}
                    cx={2}
                    r={2}
                    style={{ zIndex: "65" }}
                  ></circle>
                </g>
              </>
            ))}
          </g>
        </svg>
        <g className="FakeTextGrp">
          {yScale.domain().map((tickValue) => (
            <text
              key={tickValue}
              className="FakeText"
              // x={11}
              // dy="3.71em"
              // y={109}
            >
              {tickValue}
            </text>
          ))}{" "}
        </g>
      </div>
    </>
  );
}
